import { ActionIcon, type ActionIconProps, Tooltip } from '@mantine/core';
import type { ComponentPropsWithoutRef, Ref } from 'react';

type ButtonProps = Pick<ComponentPropsWithoutRef<'button'>, 'type' | 'aria-label' | 'onClick'>;

// ButtonProps extends after ActionIconProps to ensure button-specific props take precedence
export interface TooltipIconButtonProps extends ActionIconProps, ButtonProps {
  tooltip: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  ref?: Ref<HTMLButtonElement>;
}

/** Icon button with tooltip that appears on hover, using Mantine's ActionIcon with preset styling. */
export function TooltipIconButton({ children, tooltip, position = 'bottom', ref, ...rest }: TooltipIconButtonProps) {
  return (
    <Tooltip label={tooltip} position={position} transitionProps={{ transition: 'pop' }} withArrow>
      <ActionIcon color="white" size="xs" variant="transparent" {...rest} bg="transparent" ref={ref}>
        {children}
      </ActionIcon>
    </Tooltip>
  );
}
